import { LITMUS_EXPERIMENT_NAMES } from '@cp/constants/litmusExperimentNames';
import isLitmusExperimentEnabled from '@cp/utils/isLitmusExperimentEnabled';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setNotificationToast, setNotificationsData } from 'src/reducers/notificationsSlice';
import { RootState } from 'src/store';
import { GLOBAL, LitmusExperimentResponse } from '../../constants/Global';
import { usePollingForNotificationsOnly } from '../../hooks/usePolling';
import { PollStatus } from '../../utils/polling';
import NotificationToast from '../Notifications/NotificationToast';
import {
  fetchNotifications,
  fetchNotificationsPolling,
  getStickyNotification
} from '../Notifications/NotificationsActions';
import { getNotificationWithoutPopUps } from '../Notifications/utils';
import CountTag from './CountTag';
import styles from './index.module.scss';
import { NotificationLinkProps } from './interface';

const Notifications = React.lazy(() => import('../Notifications/Notifications'));

const NotificationLink = (props: NotificationLinkProps) => {
  const { showNotifications, toggleNotifications, notificationCountClass } = props;
  const dispatch = useDispatch();

  const { unreadNotifications, isToastShown } = useSelector(
    (state: RootState) => state?.notification
  );

  const userReferenceId = useSelector((state: RootState) => state?.common?.userData?.referenceId);

  const count = getNotificationWithoutPopUps(unreadNotifications).length;
  const isCiuAgent = useSelector((state: RootState) => state.common.isCiuAgent);
  const isShowingNotifications = !isToastShown && unreadNotifications.length > 0 && !isCiuAgent;

  const [experimentResult, setExperimentResult] = useState<LitmusExperimentResponse>();

  useEffect(() => {
    isLitmusExperimentEnabled(LITMUS_EXPERIMENT_NAMES.COLLECTION_FCM_FALLBACK, {
      'x-customer-id': userReferenceId
    }).then(setExperimentResult);
  }, []);

  const { data, status } = usePollingForNotificationsOnly({
    promiseFn: fetchNotificationsPolling(),
    pollingInterval: experimentResult?.result
      ? GLOBAL.NOTIFICATIONS_POLLING_INTERVAL
      : GLOBAL.NOTIFICATIONS_LONG_POLL
  });
  useEffect(() => {
    if (data?.data && status === PollStatus.SUCCESS) {
      dispatch(setNotificationsData(data.data));
      dispatch(getStickyNotification());
    }
  }, [data?.data]);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, []);

  useEffect(() => {
    if (isShowingNotifications) {
      toast(
        <NotificationToast
          toggleNotifications={toggleNotifications}
          showNotifications={showNotifications}
        />,
        {
          className: styles.toast
        }
      );
      dispatch(setNotificationToast(true));
    }
  }, [isToastShown, unreadNotifications]);

  return (
    <>
      <div
        style={{ position: 'absolute', top: -8, right: -28 }}
        onClick={() => toggleNotifications(!showNotifications)}
      >
        <CountTag unreadNotificationCount={count} notificationCountClass={notificationCountClass} />
      </div>
      <React.Suspense fallback={<></>}>
        <Notifications
          toggleNotifications={toggleNotifications}
          showNotifications={showNotifications}
        />
      </React.Suspense>
    </>
  );
};

export { NotificationLink };
